import { defineBlock } from '@/(routers)/boards/editor/block/blockRegistry';
import { BOARD } from '@/(routers)/boards/editor/block/definitions/boards';
import { FieldStyledLabel } from '@/(routers)/boards/editor/block/definitions/fields/fieldStyledLabel';

defineBlock({
    type: 'setup',
    colour: BOARD.orange.color,
    useBoardColour: true,
    tooltip: '最初に1回だけ実行されます',
    movable: true,
    deletable: true,
    inputs: [
        {
            kind: 'dummy',
            fields: [
                { type: 'image', icon: BOARD.orange.setupIcon, name: 'SETUP_ICON' },
                {
                    type: 'field',
                    instance: () => new FieldStyledLabel('セットアップ', { fontSize: 15, fontWeight: 'bold' }),
                },
                { type: 'label', text: ' ' },
                { type: 'label', text: '最初の1回だけ動く ' },
            ],
        },
        { kind: 'statement', name: 'SETUP', fields: [] },
        { kind: 'dummy_hidden', name: 'BAUD_HOLDER', fields: [{ type: 'number', name: 'BAUD', value: 9600 }] },
    ],
});
